import { Component, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-no-of-guests-input',
  templateUrl: './no-of-guests-input.component.html',
  styleUrls: ['./no-of-guests-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NoOfGuestsInputComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => NoOfGuestsInputComponent),
      multi: true
    }
  ]
})
export class NoOfGuestsInputComponent implements OnInit, ControlValueAccessor, Validator {
  noOfAdults: number = 0;
  noOfChildren: number = 0;
  noOfInfants: number = 0;

  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  constructor() {}

  ngOnInit() {}
  

  updateGuests() {
    const value = {
      noOfAdults: this.noOfAdults,
      noOfChildren: this.noOfChildren,
      noOfInfants: this.noOfInfants
    };
    this.onChange(value);
  }

  writeValue(value: any): void {
    if (value) {
      this.noOfAdults = value.noOfAdults || 0;
      this.noOfChildren = value.noOfChildren || 0;
      this.noOfInfants = value.noOfInfants || 0;
    }
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  // Validator implementation
  validate(control: AbstractControl): ValidationErrors | null {
    if (this.noOfAdults === 0) {
      return { noOfAdultsInvalid: true };
    }
    return null;
  }
}
